module.exports = __webpack_public_path__ + "img/close-ic.c45cb6dc.svg";